import { fetchContent } from "./contentful";

const allArticlesQuery = () => `
query {
  blogArticleCollection {
    items {
      slug
      date
    }
  }
}
`;

const blogArticlesQuery = ({ order = "date_DESC", limit, skip }) => `
query {
	blogArticleCollection(order:${order}, limit:${limit}, skip:${skip}) {
    total
    items {
      __typename
      title
      slug
      date
      category
      author
      illustrator
      interviewer
      photographer
      featuredImage {
        title
        description
        url
      }
    }
  }
}`;

const blogArticleQuery = ({ slug }) => `
query {
  blogArticleCollection(where: {slug:"${slug}"}, limit: 1) {
    items {
      title
      slug
      template
      date
      category
      author
      illustrator
      interviewer
      photographer
      video
      featuring
      featuredImage {
        title
        description
        url
      }
      featuredVideo {
        title
        description
        url
      }
      cloudinaryVideo
      youtubeEmbed
      soundcloudEmbed
      content {
        json
        links {
          assets {
            block {
              sys {
                id
              }
              title
              description
              contentType
              url
            }
          }
        }
      }
      nextStory {
        __typename
        title
        slug
        date
        category
        author
        illustrator
        interviewer
        photographer
        featuredImage {
          title
          description
          url
        }
      }
    }
  }
}
`;

const blogArticleQueryById = ({ id }) => `
query {
  blogArticle(id: "${id}", preview: true) {
    title
    slug
    template
    date
    category
    author
    illustrator
    interviewer
    photographer
    video
    featuring
    featuredImage {
      title
      description
      url
    }
    featuredVideo{
      title
      description
      url
    }
    cloudinaryVideo
    youtubeEmbed
    soundcloudEmbed
    content {
      json
      links {
        assets {
          block {
            sys {
              id
            }
            title
            description
            contentType
            url
          }
        }
      }
    }
    nextStory {
      __typename
      title
      slug
      date
      category
      author
      illustrator
      interviewer
      photographer
      featuredImage {
        title
        description
        url
      }
    }
  }
}
`;

export async function getHomePageBlogArticles() {
  const data = await fetchContent(blogArticlesQuery({ limit: 6, skip: 0 }));

  if (!data) return null;

  return data.data.blogArticleCollection.items;
}

export async function getAllArticles() {
  const data = await fetchContent(allArticlesQuery());

  if (!data) return null;

  return data.data.blogArticleCollection.items;
}

export async function getBlogArticles({ limit, skip }) {
  const data = await fetchContent(blogArticlesQuery({ limit, skip }));

  if (!data) return null;

  return data.data.blogArticleCollection;
}

export async function getBlogArticle(slug) {
  const data = await fetchContent(blogArticleQuery({ slug }));

  if (!data) return null;

  return data.data.blogArticleCollection.items[0];
}

export async function getBlogArticlePreview(id) {
  const data = await fetchContent(blogArticleQueryById({ id }), true);

  if (!data) return null;

  return data.data.blogArticle;
}
